import {
  checkActionPermission,
  checkPermission,
} from "../../core/routes/RouteValidator";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { InventoryService } from "./Service";
import $ from "jquery";
import { toast } from "react-hot-toast";
import XConstants from "../../core/config/Constants";
import { useEffect } from "react";

const UnitManagement = () => {
  const service = new InventoryService();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: any) => state.auth);
  const company = useSelector((state: any) => state.company);

  const getItems = () => {
    try {
      $("#items").DataTable().destroy();
    } catch (e) {
      console.log(e);
    }
    let token = localStorage.getItem("token");
    $("#items").DataTable({
      lengthMenu: [10, 20, 50, 100, 500, 1000],
      pageLength: 100,
      processing: true,
      serverSide: true,
      columnDefs: [
        {
          render: function (data: string, type: any, row: any) {
            if (data === "Active") {
              return `<p class="badge bg-success p-2 rounded-3">Active</p>`;
            } else {
              return `<p class="badge bg-danger p-2 rounded-3">Inactive</p>`;
            }
          },
          targets: 3,
        },
        {
          render: function (data: any, type: any, row: string[]) {
            if (row[3] === "Active") {
              return `<button class="btn btn-danger">Deactivate</button>`;
            } else {
              return `<button class="btn btn-success">Activate</button>`;
            }
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click(async (e: any) => {
              let allowed = checkActionPermission(user, company, "update");
              if (!allowed) {
                toast.error(
                  "You don't have permission to perform this action",
                  {}
                );
                return;
              }
              const status = rowData[3] === "Active" ? "Inactive" : "Active";
              const res = await service.updateUnit({
                id: rowData[5],
                status: status,
              });
              if (res) {
                toast.success("Status updated successfully", {});
                getItems();
              }
            });
          },
          targets: 5,
        },
        {
          render: function (data: any, type: any, row: any) {
            return `<button class="btn btn-primary">Details</button>`;
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click((e: any) => {
              let allowed = checkActionPermission(user, company, "read");
              if (!allowed) {
                toast.error(
                  "You don't have permission to perform this action",
                  {}
                );
                return;
              }
              navigate(`${location.pathname}/details/${cellData}`);
            });
          },
          targets: 6,
        },
        {
          render: function (data: any, type: any, row: any) {
            return `<button class="btn btn-danger">Delete</button>`;
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click(async (e: any) => {
              let allowed = checkActionPermission(user, company, "delete");
              if (!allowed) {
                toast.error(
                  "You don't have permission to perform this action",
                  {}
                );
                return;
              }
              const res = await service.updateUnit({
                id: rowData[7],
                deleted: true,
              });
              if (res) {
                toast.success("Unit deleted successfully", {});
                getItems();
              }
            });
          },
          targets: 7,
        },
      ],
      ajax: {
        url: `${XConstants.baseUrl}/company/inventory/unit/list`,
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: token,
        },
        data: function (d: any) {
          return JSON.stringify({
            ...d,
          });
        },
      },
    });
  };

  useEffect(() => {
    getItems();
  }, []);

  const exportCsv = async () => {
    toast.loading('Creating report...');
    const url = await service.exportUnit({});
    if (url) {
        window.open(url);
    }
  };

  const bulkAdd = async (file: any) => {
    toast.loading('Uploading...');
    const res = await service.uploadUnit(file, {});
    if (res) {
      toast.success(`Units added successfully`, {});
      getItems();
    }
    // Reset the file input
    document.getElementById('bulkAdd')?.setAttribute('type', 'text');
    document.getElementById('bulkAdd')?.setAttribute('type', 'file');
  }

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>Units</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li onClick={exportCsv}>
                <div
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Download"
                >
                  <a href="#" className="btn-filters" aria-expanded="false">
                    <span>
                      <i className="fe fe-download" />
                    </span>
                  </a>
                </div>
              </li>
              {checkPermission(user, company, `/units/add`) && (
                  <li>
                    <Link className="btn btn-primary"  to={`#`} onClick={() => {
                      console.log('click');
                      document.getElementById('bulkAdd')?.click();
                    }}>
                      <i className="fa fa-upload me-2" aria-hidden="true"/>
                      Bulk add Unit
                    </Link>
                    <input type="file" accept=".xlsx" id="bulkAdd" style={{display: 'none'}} onChange={(e) => {
                      // @ts-ignore
                      const file = e.target.files[0];
                      if (file) {
                        bulkAdd(file);
                      }
                    }}/>
                  </li>
              )}
              {checkPermission(user, company, `/units/add`) && (
                  <li>
                    <Link className="btn btn-primary" to={`/units/add`}>
                      <i className="fa fa-plus-circle me-2" aria-hidden="true"/>
                      Add Unit
                    </Link>
                  </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="card col-12">
          <div className="card-body w-100">
            <div className="table-responsive w-100">
              <table id="items" className="table datatable  w-100">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Symbol</th>
                    <th>Status</th>
                    <th>Added Date</th>
                    <th>Change Status</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnitManagement;
